import { useLayoutEffect, useState } from 'react';

import { findOverflowScrollParent } from '@atlaskit/editor-common/ui';
import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import { getRemixThinkingWidgetContainer } from '../../pm-plugins/remix-thinking/remix-thinking-decoration';

const isElementInViewport = ({
	element,
	root,
}: {
	element: HTMLElement;
	root: HTMLElement;
}): boolean => {
	try {
		const elementRect = element.getBoundingClientRect();
		const rootRect = root.getBoundingClientRect();
		return (
			elementRect.bottom > rootRect.top &&
			elementRect.right > rootRect.left &&
			elementRect.top < rootRect.bottom &&
			elementRect.left < rootRect.right
		);
	} catch {
		return true;
	}
};

export const useIsThinkingWidgetInViewport = ({
	editorView,
	isComplete,
}: {
	editorView?: EditorView;
	isComplete: boolean;
}): boolean => {
	const [isThinkingWidgetInViewport, setIsThinkingWidgetInViewport] = useState(true);

	useLayoutEffect(() => {
		if (!isComplete) {
			setIsThinkingWidgetInViewport(true);
			return;
		}

		if (!editorView) {
			setIsThinkingWidgetInViewport(true);
			return;
		}

		const container = getRemixThinkingWidgetContainer(editorView);
		if (!container) {
			setIsThinkingWidgetInViewport(true);
			return;
		}

		const root = findOverflowScrollParent(editorView.dom) || document.body;
		if (!root) {
			setIsThinkingWidgetInViewport(true);
			return;
		}

		const isInViewport = isElementInViewport({ element: container, root });
		setIsThinkingWidgetInViewport(isInViewport);
	}, [editorView, isComplete]);

	return isThinkingWidgetInViewport;
};
